import React from "react";
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  Text,
  SimpleGrid,
  Flex,
} from "@chakra-ui/react";
import { PresentationProps } from "./ForgotPassword.types";
import { translations } from "../../i18n/translations";
import { t } from "i18next";
import BgImg from "./assets/bg.png";
import { Logo } from "../../components/Logo/Logo";

export const ForgotPasswordPresentation = (props: PresentationProps) => {
  const { register, onSubmit, errors, isSubmitting } = props;
  const screen = translations.screens.forgotPassword;
  return (
    <SimpleGrid
      columns={[1, 1, 2, 2]}
      minH={["200px", "200px", "100vh", "100vh"]}
      spacing={0}
    >
      <Flex
        alignItems={["center", "center", "flex-start", "flex-start"]}
        bgColor="#000000db"
        bgImage={`url(${BgImg})`}
        bgSize="cover"
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        p={8}
      >
        <Logo />
      </Flex>
      <Flex
        alignItems={["center", "center", "flex-start", "flex-start"]}
        flexDirection="column"
        justifyContent="center"
        pt={["50px", "50px", 0, 0]}
        px="20%"
      >
        <Flex flexDirection="column">
          <Text fontSize="30px" fontWeight={700}>
            {t<string>(screen.welcome)}
          </Text>
          <Text color="gray.400" fontSize="16px" fontWeight={500}>
            {t<string>(screen.description)}
          </Text>
        </Flex>
        <br />
        <form style={{ minWidth: "300px" }} onSubmit={onSubmit}>
          <FormControl isInvalid={Boolean(errors.email?.message)}>
            <FormLabel htmlFor="name">{t<string>(screen.form.email)}</FormLabel>
            <Input
              id="email"
              {...register("email", {
                required: "This is required",
                minLength: { value: 4, message: "Minimum length should be 4" },
              })}
            />
            <FormErrorMessage>
              {errors.email && errors.email.message}
            </FormErrorMessage>
          </FormControl>
          <br />
          <Flex alignItems="center" justifyContent="flex-end" mt={4}>
            <Button colorScheme="blue" isLoading={isSubmitting} type="submit">
              {t<string>(screen.form.send)}
            </Button>
          </Flex>
        </form>
      </Flex>
    </SimpleGrid>
  );
};
